import { render, staticRenderFns } from "./FiltroSecao.vue?vue&type=template&id=b3e9de24&scoped=true"
import script from "./FiltroSecao.vue?vue&type=script&lang=js"
export * from "./FiltroSecao.vue?vue&type=script&lang=js"
import style0 from "./FiltroSecao.vue?vue&type=style&index=0&id=b3e9de24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e9de24",
  null
  
)

export default component.exports